// Navigation component for the admin page
import { Link, useHistory } from 'react-router-dom';
import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import { useUnsavedChanges } from 'contexts/UnsavedChangesContext';
import { Button, Icon } from '@safelyq/bulma-ui-library';
import { AdminDrawer } from '../AdminDrawer';
import { useProfile } from 'hooks/useProfile';
import { useSelector } from 'react-redux';
import useScreenWidth from '../CustomHookComponent/RenderingOnScreenSize';
import { getAvatarName } from 'constants';
import "./adminNavbarStyles.css";

const StyledNav = styled.nav.attrs(() => ({
  className: 'navbar p-1'
}))`
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
`;

// isLogoUrl: business logo (bigger) else the default chatclb icon/name
const StyledIcon = styled.img.attrs(() => ({}))`
  max-height: ${({ isLogoUrl }) => (isLogoUrl ? '3.0rem' : '2.3rem')} !important;
  width: auto;
  max-width: ${({ isLogoUrl }) => (isLogoUrl ? '12rem' : '8rem')};
  object-fit: contain;
  flex-shrink: 0;
  border-radius: ${({ isLogoUrl }) => (isLogoUrl ? '6px' : '0')};
`;
const StyledName = styled.img.attrs(() => ({}))`
  width: 70%;
  max-width: 100%;
  height: auto;
  max-height: 2.3rem !important;
  object-fit: contain;
  display: block; /* avoids extra baseline spacing */
  flex-shrink: 0;
`;

export const Navbar = ({ ...props }) => {
  const {
    // avatarName,
    onFullScreen,
    isAllowFullScreen,
    isAllowSideBar,
    isAllowNotifications,
    toggle,
    setToggle,
  } = props;

  const history = useHistory();
  const { guardNavigation } = useUnsavedChanges();
  const userInfo = useSelector(state => state?.auth?.userinfo);

  // Component will only on the screens tablet or smaller
  const screenWidth = useScreenWidth();
  const isMobileOrTablet = screenWidth <= 768;

  const [profileToggle, setProfileToggle] = useState(false);
  const businessId = useSelector(state => state?.business?.businessId)

  const isSuperAdmin = useSelector(state => state?.auth?.userinfo?.isSuperAdmin);
  const businessNameState = useSelector(state => state?.business?.businessName);
  const businessLogoUrl = useSelector(state => state?.business?.logoUrl);
  const messageCountGlobal = useSelector((state) => state?.business?.messageCount);
  const notificationCountGlobal = useSelector((state) => state?.business?.notificationCount);

  const { isLoggedIn, logout } = useProfile();

  const handleToggle = () => setToggle((prev) => !prev);

  const handleProfileToggle = () => setProfileToggle(!profileToggle);

  const handleMenuClose = () => setToggle(false);

  const handleLogout = () => {
    // Use guardNavigation to confirm navigation before logging out
    guardNavigation(() => {
      localStorage.setItem('post_logout_redirect_url', '/admin');
      localStorage.setItem('authPersist', 'false'); // change the logged in flag to false
      logout();
    });
  };

  // const logoUrl = (businessId == null || !isLoggedIn) ? `/assets/logo/0` : `/assets/logo/${businessId}`;
  // const logoUrl = businessLogoUrl || ((!!businessId) ? `/assets/logo/${businessId}` : false);
  const logoUrl = businessLogoUrl;

  return (
    <StyledNav role='navigation' aria-label='main navigation'>
      <div className='navbar-brand' style={{ width: '100%' }}>
        <a className='navbar-item py-0'
          onClick={(e) => {
            e.preventDefault();
            guardNavigation(() => {
              history.push('/admin');
              handleMenuClose();
            });
          }}>
          {logoUrl ? <StyledIcon isLogoUrl src={logoUrl} alt='logo' /> :
            <div className='is-flex' style={{ width: "150px" }}>
              <StyledIcon src='images/icon.png' alt='logo' />
              <StyledName src='images/logo.png' alt='logo' />
            </div>
          }

          {isLoggedIn && businessId ? <Customh6> <b>{businessNameState} </b></Customh6> : null}
        </a>
        <div style={{ marginLeft: 'auto' }} />
        {isLoggedIn && (
          <Fragment>
            {isAllowNotifications && (
              <Fragment>
                <>
                  {/* Messages */}
                  <div className='navbar-item pl-0'>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        guardNavigation(() => {
                          history.push(`/admin/messages/${businessId}`);
                        });
                      }} title='Messages'>
                      <span className='notification-badge-wrapper'>
                        <Button size='small' className='button-icon'> <Icon name='comments' /> </Button>
                        {messageCountGlobal > 0 && (<span className='notification-badge'> {messageCountGlobal > 9 ? '9+' : messageCountGlobal}  </span>)}
                      </span>
                    </a>
                  </div>
                  {/* Notification */}
                  <div className='navbar-item pl-1'>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        guardNavigation(() => {
                          history.push(`/admin/notifications/${businessId}`);
                        });
                      }} title='Notifications'  >
                      <span className='notification-badge-wrapper'>
                        <Button size='small' className='button-icon'> <Icon name='bell' /> </Button>
                        {notificationCountGlobal > 0 && (<span className='notification-badge'> {notificationCountGlobal > 9 ? '9+' : notificationCountGlobal}  </span>)}
                      </span>
                    </a>
                  </div>
                </>
              </Fragment>
            )}
            {isAllowFullScreen && (
              <div className='navbar-item pl-0' title='Expand Screen'>
                <Button size='small' className='button-icon' onClick={onFullScreen}  >  <Icon name='arrows-alt' />  </Button>
              </div>
            )}

            {/* Super admin / Admin details - hide only on mobile and tablets */}
            <div className='navbar-item pl-0 is-hidden-touch' title='Profile'>
              <div className={`dropdown ${profileToggle && 'is-active'} is-right`} >
                <div className='dropdown-trigger'>
                  {isSuperAdmin && (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        guardNavigation(() => {
                          history.push("/superadmin/home");
                        });
                      }} title='Notifications'  >
                      <Button size="small" color="info" style={{ marginRight: "10px" }}>
                        Super Admin
                      </Button>
                    </a>
                  )}
                  <Button size='small' color='info' light className='avatar-icon rounded' aria-controls='dropdown-menu' onClick={handleProfileToggle}  > <strong>
                    {getAvatarName(userInfo)}
                  </strong> </Button>
                </div>
                <div className='dropdown-menu' id='dropdown-menu' role='menu'>
                  <div className='dropdown-content '>
                    <a className='dropdown-item' onClick={(e) => {
                      e.preventDefault();
                      guardNavigation(
                        () => history.push('/admin/account/setting'),
                        () => handleProfileToggle()
                      );
                    }}>  Account Settings  </a>
                    <a className='dropdown-item' onClick={handleLogout}  > Logout  </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Businesses Page show nav details */}
            {
              !isAllowSideBar &&
              < div className='navbar-item pl-0 is-hidden-desktop' title='Profile'>
                <div className={`dropdown ${profileToggle && 'is-active'} is-right`} >
                  <div className='dropdown-trigger'>
                    {isSuperAdmin && (
                      <Link to="/superadmin/home">
                        <Button size="small" color="info" style={{ marginRight: "10px" }}>
                          Super Admin
                        </Button>
                      </Link>
                    )}
                    <Button size='small' color='info' light className='avatar-icon rounded' aria-controls='dropdown-menu' onClick={handleProfileToggle}>
                      <strong>
                        {getAvatarName(userInfo)}
                      </strong>
                    </Button>
                  </div>
                  <div className='dropdown-menu' id='dropdown-menu' role='menu'>
                    <div className='dropdown-content '>
                      <Link to='/admin/account/setting' className='dropdown-item' onClick={handleProfileToggle}  >  Account Settings  </Link>
                      <Link to='#' className='dropdown-item' onClick={handleLogout}  > Logout  </Link>
                    </div>
                  </div>
                </div>
              </div>
            }
          </Fragment>
        )}
        {isAllowSideBar && (
          <a role='button' className={`navbar-burger is-hidden-desktop burger m-0 ${toggle && 'is-active'}`} aria-label='menu' aria-expanded='false' data-target='mainNavbar' onClick={handleToggle} >
            <span aria-hidden='true' />
            <span aria-hidden='true' />
            <span aria-hidden='true' />
          </a>
        )}
      </div>

      {/* From here, called only for mobile, desktop variant is called from Admin Layout */}
      {isAllowSideBar && isMobileOrTablet && (
        <div className={`navbar-menu ${toggle ? 'is-active' : ''}`}>
          <AdminDrawer handleMenuClose={handleMenuClose} />
        </div>
      )}
    </StyledNav>
  );
};

const Customh6 = styled.h6`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.5rem; /* ml-3 spacing */
  margin-right: 0.5rem; /* mr-3 spacing */
     
  @media only screen and (max-width: 550px){
    max-width: 38vw;
  }
`;